<template>
    <div class="flex items-center justify-between mb-24">
        <div class="flex-1">
            <h1 class="first-letter:uppercase text-heading-2 font-semibold mb-8">{{ title }}</h1>
            <p v-if="description" class="text-primary-80 mr-32" v-html="description"></p>
        </div>
        <simple-button
            :disabled="buttonDisabled"
            display="secondary"
            :icon="buttonIcon"
            :loading="buttonLoading"
            look="primary"
            v-if="button"
            @click="$emit('button-click')"
        >
            <span class="text-nowrap">{{ button }}</span>
        </simple-button>
        <slot></slot>
    </div>
</template>
<script>
import SimpleButton from "./SimpleButton.vue";

export default {
    name: "SettingsHeading",
    components: {SimpleButton},
    props: {
        title: {
            type: String,
            required: true
        },
        description: String,
        button: String,
        buttonDisabled: Boolean,
        buttonIcon: String,
        buttonLoading: Boolean,
    }
}
</script>
<style scoped>

</style>